/**
 * @file: description
 * @author:
 * @Date: 2020-04-26 16:36:57
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-04-28 10:35:47
 */
import React from 'react';
import { openTargetBlankPage } from '@src/utils';
import { IconFont } from '@src/features/common/Icon';

interface Props {
  tagName?: string;
  tagId: number;
  className?: string;
}

import './Tag.less';

const Tag: React.SFC<Props> = (props: Props) => {
  const { tagName, tagId, className } = props;

  const toTagDetail = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    event.stopPropagation();

    openTargetBlankPage(`/tag/${tagId}`);
  };

  return (
    <div
      className={`k-tech-text-overflow-ellipsis k-tech-com-tag ${className} `}
      onClick={toTagDetail}
    >
      <IconFont type="icon-tag1" className="icon" />
      {tagName}
    </div>
  );
};

export default React.memo(Tag);
